import { READONLY_ACCESS } from "constants/AccessTypes/AccessTypes";
import React, { createContext, useReducer } from "react";
import { localiseCaptionPayload, localiseDefaultCaptions } from "i18n";

const initialState = {
	showAdd: false,
	openConfirmationModal: false,
	headerImportConfig: null,
	headerIconActionConfig: null,
	details: {},
	isActive: false,
	defaultCustomCaptionsData: {},
	apiErrorPresent: true,
	loading: true,
	isReadOnly:
		(
			JSON.parse(sessionStorage.getItem("me")) ||
			JSON.parse(localStorage.getItem("me"))
		)?.position?.settingsAccess === READONLY_ACCESS,
	// haveData: false,
};

function reducer(state, action) {
	switch (action.type) {
		case "ADD_TOGGLE":
			return {
				...state,
				showAdd: !state.showAdd,
			};

		case "SET_SITE_APP_DETAIL": {
			// The *CC caption columns drive labels across the admin screens, so
			// localise them to the active language (or pseudo). English passes
			// through unchanged. No routed screen edits *CC values from this
			// context for a non-English locale, so this cannot leak into a save.
			return {
				...state,
				details: localiseCaptionPayload(action.payload),
			};
		}

		case "RESET_SITE_APP_DETAIL": {
			return {
				showAdd: false,
				openConfirmationModal: false,
				headerImportConfig: null,
				headerIconActionConfig: null,
				details: {},
				isActive: false,
				defaultCustomCaptionsData: {},
			};
		}

		case "TOGGLE_CONFIRMATION_MODAL": {
			return {
				...state,
				openConfirmationModal: action.payload,
			};
		}

		case "SET_HEADER_IMPORT": {
			return {
				...state,
				headerImportConfig: action.payload,
			};
		}

		case "CLEAR_HEADER_IMPORT": {
			return {
				...state,
				headerImportConfig: null,
			};
		}

		case "SET_HEADER_ICON_ACTION": {
			return {
				...state,
				headerIconActionConfig: action.payload,
			};
		}

		case "CLEAR_HEADER_ICON_ACTION": {
			return {
				...state,
				headerIconActionConfig: null,
			};
		}

		case "TOGGLE_ISACTIVE": {
			return {
				...state,
				isActive: action.payload,
			};
		}

		case "DEFAULT_CUSTOM_CAPTIONS_DATA": {
			return {
				...state,
				defaultCustomCaptionsData: localiseDefaultCaptions(action.payload),
			};
		}

		case "LOADING_COMPLETED":
			return {
				...state,
				loading: false,
			};

		case "CHANGE_ISREADONLY":
			return {
				...state,
				isReadOnly: action.payload,
			};

		default:
			return state;
	}
}

export const SiteContext = createContext();
const SiteApplicationContext = ({ children }) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	
	return (
		<SiteContext.Provider value={[state, dispatch]}>
			{children}
		</SiteContext.Provider>
	);
};

export default SiteApplicationContext;
